import { render } from "./Help.vue?vue&type=template&id=6a42bc7a&scoped=true&ts=true"
import script from "./Help.vue?vue&type=script&lang=ts"
export * from "./Help.vue?vue&type=script&lang=ts"

import "./Help.vue?vue&type=style&index=0&id=6a42bc7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a42bc7a"]])

export default __exports__